export default __webpack_public_path__ + "clock-small.84f2d977.svg";